import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 16v-13","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5l2.5 2.5","key":"svg-2"}]]

const IconArrowUpRhombus = createReactComponent('outline', 'arrow-up-rhombus', 'ArrowUpRhombus', __iconNode);

export default IconArrowUpRhombus;